/**
 * Second path segments under /shop that are pages, not artist slugs. Must stay
 * in sync with the routes in customer-web/src/index.tsx.
 */
export const RESERVED_SHOP_SEGMENTS = [
  'flash',
  'service',
  'services',
  'request',
  'gift-cards',
  'subscribe',
  'check-in',
  'preview-waiver',
  'waiver-session',
  'my-gift-cards',
];

export interface BookingSitePath {
  shop?: string;
  artist?: string;
}

/** Which theme owner a URL belongs to. Null when it is not a booking site page. */
export function parseBookingSitePath(pathname: string): BookingSitePath | null {
  const parts = pathname.split('/').filter(Boolean);

  if (parts[0] === 'shop' && parts[1]) {
    const second = parts[2];
    const artist =
      second && !RESERVED_SHOP_SEGMENTS.includes(second) ? second : undefined;
    return { shop: parts[1], artist };
  }

  if (parts[0] === 'artist' && parts[1]) {
    return { artist: parts[1] };
  }

  return null;
}
